import { Model } from "pinia-orm";
import { CertificationProjectStep, Cycle, Examination } from "@/models";

export default class Step extends Model {
  static entity = "steps";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      name: this.string(""),
      order: this.attr(null),
      code: this.string(""),
      startApplication: this.attr(0),
      endApplication: this.attr(0),
      price: this.attr(0),
      stepType: this.string(""),
      hasReceivability: this.boolean(true),
      descriptionReceivability: this.string(""),
      certifProjectStatusIn: this.string(""),
      certifProjectStatusSuccessOut: this.string(""),
      certifProjectStatusFailOut: this.string(""),
      certifProjectBeginsAtDuration: this.attr(null),
      certifProjectEndsAtDuration: this.attr(null),
      isDisplayed: this.boolean(true),
      // Foreign keys
      cycleUuid: this.string(""),
      cycleData: this.belongsTo(Cycle, "cycleUuid"),
      examinationsList: this.hasMany(Examination, "stepUuid"),
      certificationProjectStepsList: this.hasMany(CertificationProjectStep, "stepUuid"),
    };
  }
}
